<div class="grow grow--min grey-50-bg">
  <fin-check-in-subheader
    [bound]="bound$ | async"
    [locations]="locations$ | async"
    (exitCheckIn)="exitCheckIn()"
    (viewFlightDetails)="viewFlightDetailsOpen$.next(true)"
  />
  <div class="grid-max-width center grid-col-12 no-row-gap ng-star-inserted">
    <div class="col-f md-col-3-10 xl-col-4-9">
      @if (showNavigateBackButton$ | async) {
        <div class="flex font-body-1 pr-small-t">
          <fcom-button
            data-testid="check-in-navigate-back-button"
            class="back-button"
            [attr.title]="'actions.back' | finLocalization"
            [icon]="{
              name: SvgLibraryIcon.CHEVRON_LEFT,

              position: IconPosition.LEFT,
            }"
            [theme]="ButtonTheme.LIGHT_TERTIARY_GHOST"
            [text]="'MMB.checkIn.funnel.actions.navigateBack' | finLocalization"
            (clickBtn)="navigateBack()"
          />
        </div>
      }
      @if (
        (currentStep$ | async) !== CheckInStep.CONFIRMATION &&
        (currentStep$ | async) !== CheckInStep.VOLUNTARY_DENIED_BOARDING
      ) {
        <div class="flex flex--space-between flex--middle">
          <h1 data-testid="page-title" class="ps-large-y ps-large-r font-heading-3">
            {{ pageTitle$ | async | finLocalization }}
          </h1>
          <fcom-stepper
            [activeStep]="currentStepNumber$ | async"
            [steps]="stepperSteps$ | async"
            [mode]="StepperMode.RADIAL"
          />
        </div>
      }
      <router-outlet />
    </div>
  </div>
</div>

<fcom-modal
  data-testid="itinerary-timeline-modal"
  [open]="viewFlightDetailsOpen$ | async"
  (close)="viewFlightDetailsOpen$.next(false)"
  (openChange)="viewFlightDetailsOpen$.next(true)"
  [title]="'MMB.view.itineraryModal.title' | finLocalization"
  [buttons]="ModalButtons.DONE"
  [shouldAddPaddingTop]="isInsideApp"
>
  <fin-itinerary-timeline
    [bound]="bound$ | async"
    [locations]="locations$ | async"
    [boundType]="BoundType.outbound"
    class="block pr-medium"
  />
</fcom-modal>

<fcom-modal
  [open]="closeSeatChangesModalOpen$ | async"
  [fitToContent]="true"
  [buttons]="ModalButtons.CONTINUE_CANCEL"
  [title]="'MMB.checkIn.steps.seats.modal.exit.title' | finLocalization"
  (close)="closeSeatChangesModalOpen$.next(false)"
  (confirm)="showSeatChangesModalOrNavigateBack(true)"
  [shouldAddPaddingTop]="isInsideApp"
>
  <p class="pr-large font-body-1">
    {{ 'MMB.checkIn.steps.seats.modal.exit.content' | finLocalization }}
  </p>
</fcom-modal>

@if (showExitRowSeatsNotification$ | async) {
  <fin-check-in-exit-row-seats
    [exitRowSeats]="exitRowSeatsToConfirm$ | async"
    (confirmExitRowSeats)="onConfirmExitRowSeats($event)"
  />
}

@if (reassigningSeatsModalLoader$ | async) {
  <fcom-modal
    [fitToContent]="true"
    [forceRemainOpen]="true"
    [open]="true"
    [title]="'MMB.checkIn.review.titles.reassigningSeats' | finLocalization"
    [buttons]="null"
    [shouldAddPaddingTop]="isInsideApp"
  >
    <fcom-loader aria-live="polite" [paragraph]="'MMB.checkIn.review.reassigningSeats'" />
  </fcom-modal>
}
